<li class="btn list-item {{stateClass}}">
  <h3 class="line-break icon-left icon-l ui-icon-{{item.icon}}">{{item.shortLabel}}</h3>
</li>
